import { ofType } from 'redux-observable';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { EMPTY, from, of } from 'rxjs';
import { GET_USER_DATA } from '../auth.const';
import { httpMethods, request } from '../../../../services/http-service';
import { updateUserAction } from '../auth.action';

const epic = (action$: any) =>
  action$.pipe(
    ofType(GET_USER_DATA),
    map(({ payload }: any) => payload),
    switchMap(() =>
      from(request({ path: `user/me`, method: httpMethods.GET })).pipe(
        map((p: any) => p?.result),
        // tap(p => console.log(`[epic ${GET_USER_DATA}]`, p)),
        switchMap(data => of(updateUserAction(data))),
        catchError(err => {
          console.error(`[epic ${GET_USER_DATA}] error`, err);
          return EMPTY;
        })
      )
    )
    // switchMap(() => EMPTY)
  );

export default epic;
